module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_flower-167444fe8b2dc8d41c8defb507144df4.webp";